import { render } from "./ScrollNumber.vue?vue&type=template&id=e832d054"
import script from "./ScrollNumber.vue?vue&type=script&lang=js"
export * from "./ScrollNumber.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/prd-cce-chain-browser-static-nft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__